import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import Icon from "components/library/Icon";
import RevisionsListPopover from "editor/components/RevisionsList/RevisionsListPopover";
import { DATETIME_FORMAT } from "config/constants";

import styles from "./RevisionsListItem.css";

export default class RevisionsListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuActive: false,
      element: null,
    };
    this.toggleMenu = this._toggleMenu.bind(this);
  }

  _toggleMenu() {
    this.setState({ isMenuActive: !this.state.isMenuActive });
  }

  formatDate(date) {
    return moment(date).format(DATETIME_FORMAT);
  }

  render() {
    const comment =
      this.props.comment !== "Auto revision" ? this.props.comment : false;

    return (
      <div className={styles.root}>
        <div className={styles.main}>
          <div className={styles.rowSection}>
            <div className={styles.name}>{this.props.user.display_name}</div>
            <div className={styles.date}>
              {this.formatDate(this.props.dateCreated)}
            </div>
          </div>

          <div className={styles.rowSection}>
            {comment ? <div className={styles.column}>{comment}</div> : null}
            {this.props.wordcount ? (
              <div className={styles.column}>{this.props.wordcount} words</div>
            ) : null}
          </div>
        </div>

        <div
          className={styles.elipses}
          onClick={this.toggleMenu}
          ref={element => {
            if (!this.state.element) {
              this.setState({ element: element });
            }
          }}
        >
          <RevisionsListPopover
            element={this.state.element}
            closeModal={this.toggleMenu}
            isActive={this.state.isMenuActive}
            {...this.props}
          />
          <Icon
            name="dots/horizontal"
            description="more"
            className={styles.icon}
          />
        </div>
      </div>
    );
  }
}

RevisionsListItem.propTypes = {
  user: PropTypes.object.isRequired,
  dateCreated: PropTypes.string.isRequired,
  wordcount: PropTypes.number,
  comment: PropTypes.string.isRequired,
  revisionId: PropTypes.number.isRequired,
};
